// is this really better than normal case? Have to-remap in components for TS
export enum VacationScheduleMutations {
  RESET = "RESET",
  SET_SCHEDULES = "SET_SCHEDULES",
}
